<template>
    <div class="col-lg-8">
        <div class="compare-offers-panel"  v-model="isClear">
            <div class="profile-block d-flex flex-wrap justify-content-between align-items-center">
                <h3 class="profile-block-heading">
                    {{ lang.favoriteOffersCompare }}
                </h3>
                <template v-if="this.favoritesUpdated.length > 0  && isClear === false">
                    <p>{{ lang.favoriteOffersInfo }}</p>
                </template>
            </div>
            <template v-if="this.favoritesUpdated.length > 0  && isClear === false">
                <div class="newest-offers swiper-container">
                    <div class="arrows-panel">
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                    </div>

                    <div class="offer-wrapper swiper-wrapper">
                        <div class="offer-panel swiper-slide"
                             v-for="offer in favoritesUpdated"
                             :key="offer.property ? offer.property.id : ''">

                            <template v-if="offer.property">
                                <span class="checkbox-star-panel" data-toggle="tooltip" :data-original-title="lang.favoriteOffers">
                                    <label class="checkbox-star"

                                           @click="updateFavorites(offer.property_id )">

                                        <input type="checkbox" name="favorites" :checked="true" disabled>
                                        <span class="checkmark"></span>
                                    </label>
                                </span>
                                <div class="offer">
                                    <a :href="offer.property.slug ? prefixEn + '/properties/'+offer.property.slug : '#'" :title="offer.property.title ? offer.property.title : ''">
                                        <div class="offer-image">
                                            <div class="offer-image zoom" :style="{ 'background-image': 'url(' + (offer.property.first_media_url ? offer.property.first_media_url : '/assets/images/placeholders/placeholder-small.jpg') + ')' }"></div>
                                        </div>
                                    </a>
                                    <div class="offer-text">
                                        <a :href="offer.property ? prefixEn + '/properties/'+offer.property.slug : '#'" :title="offer.property ? offer.property.title : ''">
                                            <h5 class="offer-title"> {{ offer.property ? offer.property.title : '' }}</h5>
                                        </a>
                                        <div class="offer-text-row">
                                            <span class="text-regular min-w-75px">{{ lang.address }}: </span>
                                            <span class="text-regular ellipsis">{{ offer.property ? offer.property.address : '' }}</span>

                                        </div>
                                        <div class="offer-list-panel">
                                            <ul class="offer-list">
                                                <li class="offer-list-item">
                                                    <span class="text-regular two-lines">{{ lang.building_status }}: </span>
                                                    <span class="item-info"> {{ offer.property ? offer.property.building_status : '' }}</span>
                                                </li>
                                                <li class="offer-list-item">
                                                    <span class="text-regular two-lines">{{ lang.building_class }}: </span>
                                                    <span class="item-info"> {{ offer.property ? offer.property.building_class : '' }}</span>
                                                </li>
                                                <li class="offer-list-item">
                                                    <span class="text-regular two-lines">{{ lang.date_of_permit }}: </span>
                                                    <span class="item-info"> {{  offer.property ? offer.property.date_of_permit : ''}}</span>
                                                </li>
                                                <li class="offer-list-item">
                                                    <span class="text-regular">{{ lang.total_floorage }}: </span>
                                                    <span class="item-info"> {{ offer.property ? offer.property.total_floorage : '' }} {{ lang.sq_m }}</span>
                                                </li>
                                                <li class="offer-list-item">
                                                    <span class="text-regular">{{ lang.percent_of_common_parts }}: </span>
                                                    <span class="item-info"> {{ offer.property ? offer.property.percent_of_common_parts : '' }}%</span>
                                                </li>
                                                <li class="offer-list-item">
                                                    <span class="text-regular">{{ lang.floor }}: </span>
                                                    <span class="item-info"> {{ offer.property ? offer.property.floor : '' }}</span>
                                                </li>
                                                <li class="offer-list-item summary pt-3">
                                                    <span class="text-regular">{{ lang.monthly_rent }}: </span>
                                                    <span class="text-bold">{{ offer.property ? offer.property.monthly_rent : '' }} €</span>
                                                </li>
                                                <li class="offer-list-item summary">
                                                    <span class="text-regular">{{ lang.sq_m_rent }}: </span>
                                                    <template v-if="offer.property">
                                                        <span class="text-bold coral">{{ Math.round(offer.property.monthly_rent / offer.property.total_floorage * 100) / 100 }} € / {{ lang.sq_m }} </span>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="swiper-scrollbar"></div>
                </div>
                </template>

                <template v-else>
                    <h4 class="no-offers">{{ lang.no_offers }}</h4>
                </template>
            </div>
        </div>
</template>

<script>

    import { SaveToFavorites } from '../../../scripts/save-to-favorites/save-to-favorites';
    import axios from "axios";
    const Swiper = require('swiper/js/swiper.js');

    const lang = $('body').data().locale;
    const enPrefix = lang === 'en' ? '/en' : '';

    export default {
        name: "FavoriteOffersCompare",
        props: {
            userFavorites: '',
            userFavoritesClear: '',

            userIsFavoritesUpdate: '',
            userFavoritesUpdate: ''
        },
        data: function() {
            return {
                offers: this.userFavorites,
                offersClear: this.userFavoritesClear,

                prefixEn: enPrefix,

                isOffersUpdate: this.userIsFavoritesUpdate,
                updatedOffers: this.userFavoritesUpdate,

                //**** Translations *****//
                lang: jsLangs
            }
        },
        methods: {
            saveToFavorites: function() {
                SaveToFavorites();
            },

            /*** Method - Update Favorites (Remove single item onclick) ***/
            updateFavorites: function(propertyID) {

                /**** Updated Offer List ****/
                this.updatedOffers = this.favoritesUpdated;

                /***** Emit Value ******/
                this.$emit("is-favorites-updated", this.isOffersUpdate = true);

                this.updatedOffers.map((item) => {
                    if (item.property.id === propertyID) {
                        $.ajax({
                            url: `${enPrefix}/properties/${ propertyID }/favorite`,
                            type: 'GET',
                            data: {
                                favorite: false
                            },
                            success: () => {
                                toastr.info(lang.toastrMsg_removedFromFavorites, lang.toastrMsg_removedFromFavoritesTitle);
                                // toastr.info('Обявата е премахната от "Любими"', 'Премахване на обява');
                                $("[data-toggle='tooltip']").tooltip('dispose');

                                /** TODO find alternative method to remove item (remove by index does not work) ***/
                                this.updatedOffers.splice(this.updatedOffers.indexOf(item), 1);

                                /* Updated */
                                this.$emit("favorites-updated", this.updatedOffers);
                            },
                            complete: function() { },
                            error: function (err) {
                                console.log(err);
                            }
                        });

                    }
                });
            },
        },
        computed: {
            /*** Watch if 'Clear All' button is checked ***/
            isClear: function () {
                return this.offersClear;
            },
            isFavoritesUpdate: function () {
                return this.isOffersUpdate;
            },

            favoritesUpdated: function () {

                if (this.updatedOffers.length === 0 && this.isOffersUpdate === true) {

                    return this.offers = [];

                } else if (this.isOffersUpdate === true) {

                    return this.updatedOffers;

                } else {

                    return this.offers;
                }
            },
        },
        mounted() {
            // Init and config 'offers' slider
            // console.log(this.offers);
            const swiper = new Swiper('.swiper-container', {
                slidesPerView: 1,
                // centeredSlides: true,
                // // initialSlide: 0,
                spaceBetween: 10,
                grabCursor: true,
                loop: false,
                // autoResize: false,
                lazy: {
                    loadPrevNext: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                }
            });
            /*** Init 'Save to Favourites' Method ***/
            this.saveToFavorites();

            console.log(this.offers);
        }
    }
</script>